export default __webpack_public_path__ + "static/media/downArrow.ea05cc15.svg";